import React, { useEffect, useState } from "react";
import { useParams } from 'react-router-dom';
import Map, { Source, Layer, Marker, Popup, NavigationControl } from "react-map-gl";
import "mapbox-gl/dist/mapbox-gl.css";
import axios from "axios";
import { URL_BASE } from "../../config/url-server";
import { Divider, Spin } from "antd";
import config from "../../config/config"; // Aquí debe estar tu token de Mapbox
import { Link } from "react-router-dom";
import lotService from "../../services/lot-service";
import { toast, ToastContainer } from "react-toastify";
import { Controller, useForm } from "react-hook-form";

const LinePalmEdition = () => {


    const { lotId } = useParams();
    const [title, setTitle] = useState("Finca - Lote");

    const {
        control,
        register,
        handleSubmit,
        setValue,
        getValues,
        reset,
        formState: { errors },
    } = useForm();


    const [lineShow, setLineShow] = useState("")
    const [line, setLine] = useState(0)
    const [palm, setPalm] = useState(0)
    const [selectedPoint, setSelectedPoint] = useState(null); // Punto seleccionado para el popup
    const [lotPalmsLayer, setLotPalmsLayer] = useState(null);
    const [mapLoaded, setMapLoaded] = useState(false);
    const [centerMap, setCenterMap] = useState({ lat: 10.5582, lng: -74.1915 });
    const [markerData, setMarkerData] = useState([]);
    const [popupInfo, setPopupInfo] = useState(null);
    const [loading, setLoading] = useState(true);
    const [tileset, setTileset] = useState(null);
    const clientId = localStorage.getItem("client");
    const accessToken = localStorage.getItem("token");



    const [latitudeTXT, setLatitudeTXT] = useState("LATITUD")
    const [longitudeTXT, setLongitudeTXT] = useState("LONGITUD")

    const [viewState, setViewState] = useState({
        latitude: 5.391078, // Se actualizará dinámicamente
        longitude: -73.869958, // Se actualizará dinámicamente
        zoom: 5, // Zoom inicial
    });


    const setLineName = (e) => {
        const value = e.target.value
        setLine(value)
        setPalm(1)
    }

    const setPalmName = (e) => {
        const value = e.target.value
        setPalm(value)
    }

    const cambiarLineaPalma = async (id) => {
        try {
            const params = { id, line, palm };
            const response = await lotService.updateLinePalm(params);

            if (response.success == 1||response.success == 2) {

                if (response.success == 1)
                    toast.success(response.message)
                if (response.success == 2)
                    toast.info(response.message)


                // 👉 Actualizar el marker localmente
                setMarkerData(prev =>
                    prev.map(p =>
                        p._id === id
                            ? {
                                ...p,
                                lineName: line,
                                palmName: palm,
                                updated: true
                            }
                            : p
                    )
                );

                const nextPalm = parseInt(palm) + 1
                setPalm(nextPalm)
                setSelectedPoint(null);
            }
            else {
                toast.error(response.message)
            }


        } catch (error) {
            console.log(error);
            toast.error("Error al actualizar");
        }
    };


    //juancpinedam.7rb27w8d



    const loadLotPositions = async () => {
        try {
            const params = { lotId, line: lineShow };
            const configAxios = {
                headers: {
                    client: clientId,
                    Authorization: `Bearer ${accessToken}`,
                },
                params,
            };

            const response = await axios.get(URL_BASE + "map/map-lot", configAxios);
            const lot_name = response.data.lotName;
            const farm_name = response.data.farmName;
            setTitle(`${farm_name} -  ${lot_name}`)
            const palms = response.data.data;
            const tilesetWeb = response.data.tileset;
            setTileset(tilesetWeb)


            if (palms.length > 0) {
                const middle = Math.floor(palms.length / 2);
                const coords = palms[middle]?.location?.coordinates;

                if (coords && coords.length === 2) {
                    const lat = coords[1];
                    const lng = coords[0];
                    setCenterMap({ lat, lng });

                    setViewState({
                        latitude: lat,
                        longitude: lng,
                        zoom: 18,
                    });
                }


            }

            setMarkerData(palms);

            console.log("palms en load positions", palms)




            const filterCoord = palms.map((location, index) => {
                const [lng, lat] = location.location.coordinates;
                const name = `${location.lineName}-${location.palmName}`;

                return (
                    <Marker
                        key={`lot-palm-${index}`}
                        longitude={lng}
                        latitude={lat}
                        anchor="center"
                        onClick={() => {
                            setSelectedPoint(location);
                            setLine(location.lineName);
                            setPalm(location.palmName);
                        }}
                    >
                        <div
                            onClick={() => {
                                console.log(location)
                                setSelectedPoint(location)
                            }
                            }
                            style={{
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                backgroundColor: "white",
                                border: `2px solid #000`,
                                padding: "2px 4px",
                                borderRadius: "6px",
                                cursor: "pointer",
                                fontSize: "10px",
                                color: "#000",
                                fontWeight: "bold",
                                whiteSpace: "nowrap",
                            }}
                            title={name}
                        >
                            {name}
                        </div>
                    </Marker>
                );
            });




            setLotPalmsLayer(filterCoord)





        } catch (error) {
            console.error("Error obteniendo las palmas:", error);
        } finally {
            setLoading(false);
        }
    };


    const isValidCoordinate = (coord) => {


        return (
            Array.isArray(coord) &&
            coord.length === 2 &&
            typeof coord[0] === 'number' &&
            typeof coord[1] === 'number' &&
            !isNaN(coord[0]) &&
            !isNaN(coord[1])
        );
    };


    const setLineValue = (e) => {
        const valor = e.target.value
        setLineShow(valor)
    }


    const loadLine = () => {
        loadLotPositions();
    }


    const addLine = () => {

        let lineName = getValues("line")

        let nextLine = parseInt(lineName) + 1
        setValue("line", nextLine)
        setValue("palm", 1)
        setLine(nextLine)
        setPalm(1)

    }




    useEffect(() => {
        loadLotPositions();
    }, []);


    useEffect(() => {
        const markers = markerData.map((marker) => {
            const [lng, lat] = marker.location.coordinates;
            const name = `${marker.lineName}-${marker.palmName}`;

            return (
                <Marker
                    key={marker._id}
                    latitude={lat}
                    longitude={lng}
                    anchor="center"
                >
                    <div
                        onClick={() => setSelectedPoint(marker)}
                        style={{
                            backgroundColor: marker.updated ? "#f0bab8ff" : "white",
                            border: marker.updated ? "2px solid #cc2e2eff" : "2px solid #000",
                            padding: "2px 4px",
                            borderRadius: "6px",
                            cursor: "pointer",
                            fontSize: "10px",
                            fontWeight: "bold",
                        }}
                    >
                        {name}
                    </div>
                </Marker>
            );
        });

        setLotPalmsLayer(markers);
    }, [markerData]);


    return (
        <div >
            <ToastContainer />
            <div className="col-12 " style={{ marginTop: "-10px" }}>
                <Divider orientation="left" style={{ border: "#AAAAAA" }} >

                    <Link to="/admin-lots" className="nav-link link-primary p-1">
                        <i className="bi bi-arrow-left-short fa-lg"></i>
                        <span className="fs-6 m-1">
                            <strong>REGRESAR</strong>
                            <label className="text-secondary ms-3">  MAPA - {title} </label>
                        </span>
                    </Link>
                    ({latitudeTXT}) ({longitudeTXT})
                    <input type="number" value={lineShow} onChange={setLineValue}></input>
                    <input type="button" value="Cargar linea" onClick={loadLine} ></input>
                </Divider>
            </div>


            <Map
                {...viewState} // Aplicar el estado de la vista dinámica
                onMove={evt => setViewState(evt.viewState)} // Permitir mover el mapa
                onClick={(event) => {
                    const lng = event.lngLat.lng;
                    const lat = event.lngLat.lat;
                    setLatitudeTXT(lat)
                    setLongitudeTXT(lng)
                    console.log("CLICK EN MAPA:");
                    console.log("Latitud:", lat);
                    console.log("Longitud:", lng);
                }}
                style={{ width: "100%", height: "100vh" }}
                mapStyle="mapbox://styles/mapbox/satellite-v9" // Mapa satelital
                mapboxAccessToken="pk.eyJ1IjoianVhbmNwaW5lZGFtIiwiYSI6ImNtNXlyNmxtbjBubm0ya3B5ZHVnMWgwcWYifQ.dogzl3DX9PMO9QywZ8CbyA"
            >

                <NavigationControl position="top-left" />

                {lotPalmsLayer}


                {selectedPoint && selectedPoint.location?.coordinates && (
                    <Popup
                        longitude={selectedPoint.location.coordinates[0]}
                        latitude={selectedPoint.location.coordinates[1]}
                        onClose={() => setSelectedPoint(null)}
                        closeOnClick={false}

                    >
                        <div>

                            <p className="text-success" ><strong>Linea-Palma</strong></p>
                            <hr></hr>
                            <form className="form-react">
                                <table>

                                    <tr>
                                        <td>Linea</td>
                                        <td>
                                            <input
                                                type="number"
                                                value={line}
                                                {...register("line")}
                                                onChange={setLineName}
                                                onKeyDown={(e) => {
                                                    if (e.key === "Enter") {
                                                        console.log("ENTER PRESIONADO");
                                                        cambiarLineaPalma(selectedPoint._id)
                                                    }
                                                }}
                                            />
                                        </td>

                                    </tr>
                                    <tr>
                                        <td>Palma</td>
                                        <td>
                                            <input
                                                type="number"
                                                value={palm}
                                                {...register("palm")}
                                                onChange={setPalmName}
                                                onKeyDown={(e) => {
                                                    if (e.key === "Enter") {
                                                        console.log("ENTER PRESIONADO");
                                                        cambiarLineaPalma(selectedPoint._id)
                                                    }
                                                }}
                                            />
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>Latitud</td>
                                        <td>{selectedPoint.location.coordinates[1] || "N/A"}</td>

                                    </tr>
                                    <tr>
                                        <td>Longitud</td>
                                        <td>{selectedPoint.location.coordinates[0] || "N/A"}</td>
                                    </tr>
                                </table>
                            </form>
                            <hr></hr>
                            <button onClick={() => addLine()} className="btn-success text-white mt-2 w-100">Sumar una linea</button>
                            <button onClick={() => cambiarLineaPalma(selectedPoint._id)} className="btn-primary text-white mt-3 w-100">Editar</button>
                        </div>
                    </Popup>
                )}

                {tileset && (
                    <>
                        <Source
                            id="ortomosaico"
                            type="raster"
                            url={`mapbox://${tileset}`}
                            tileSize={256}
                        />
                        <Layer
                            id="ortomosaico-layer"
                            type="raster"
                            source="ortomosaico"
                            paint={{ "raster-opacity": 1 }}
                        />
                    </>
                )}
            </Map>

        </div>
    );
};

export default LinePalmEdition;
